import { render } from "./ResultadoNoticia.vue?vue&type=template&id=0fb5c522&scoped=true"
import script from "./ResultadoNoticia.vue?vue&type=script&lang=js"
export * from "./ResultadoNoticia.vue?vue&type=script&lang=js"

import "./ResultadoNoticia.vue?vue&type=style&index=0&id=0fb5c522&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb5c522"]])

export default __exports__